/*
 * @Author: 丨小小风离丨
 * @Date: 2024-01-16 18:19:40
 * @LastEditTime: 2025-01-16 16:46:25
 * @LastEditors: 丨小小风离丨
 * @FilePath: \web-school-enroll\src\page\enrollPlan\details\index.tsx
 * @Description: 
 */
import FileDisplay from "@/components/file_display";
import ModuleCont from "@/components/moduleCont";
import StatusTips from "@/components/statusTips";
import { CommmonGet } from "@/util/network/api";
import { useTopHeight96 } from "@/util/public";
import { downloadFile, imageToDataUrl, previewFile } from "@/util/util";
import { Spin, message } from "antd";
import { LgSealMark } from "lancoo-web-ui";
import { useContext, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { selectSchoolId, selectSchoolInfo, selectSchoolLevel } from "../../../store/reducers/schoolInfo";
import { selectUserId, selectUserInfo } from "../../../store/reducers/userInfo";
import { OptionFunContext, getSealMarkInfo, nameTips } from "../common/publicFunc";
import './index.scss';
import { AwesomeQR, Options } from "awesome-qr";
import { enrollInfo } from "@/page/constants";


function EnrollPlanDetails() {

  const service = {
    // detail: '/plan/previewPlan',
    detail: '/portal/homepage/planDetail'
  }

  const optionFun = useContext(OptionFunContext);

  // 页面处理
  useTopHeight96()

  const location = useLocation();
  const navigate = useNavigate();
  const urlParams = new URLSearchParams(location.search);
  const planId = urlParams.get('planId');

  const userId = useSelector(selectUserId);
  const schoolId = useSelector(selectSchoolId);
  const schoolInfo = useSelector(selectSchoolInfo);
  const { userType } = useSelector(selectUserInfo);
  const schoolLevel = useSelector(selectSchoolLevel); // 获取学校类型

  // 刷新
  const [isloading, setIsloading] = useState<boolean>(false);
  // 下载附件
  const [downFile, setdownFile] = useState<any[]>([]);
  const [info, setInfo] = useState<any>({});
  // 二维码URL
  const [qrcodeUrl, setqrcodeUrl] = useState<string>("");
  const [currentIndex, setCurrentIndex] = useState<number>(0);

  //录取信息弹窗
  const [enrollVisible, setEnrollVisible] = useState(false);

  const getcode = async () => {
    let data = "https://leave.lancooedu.com?sys=T11&type=stranger&school=" + (schoolId || info?.schoolId) + "&planId=" + (planId || info?.planId);
    const logoDataUrl = await imageToDataUrl(schoolInfo.SchoolLogos[0].logo)
    const dataUrl = await new AwesomeQR({
      text: data,
      size: 200,
      correctLevel: 3,
      logoImage: logoDataUrl
    }).draw()
    setqrcodeUrl(dataUrl as string)
  }

  const init = () => {
    setIsloading(true);
    setqrcodeUrl(null);
    // addPageView 浏览次数是否增加
    CommmonGet(service.detail, { planId, addPageView: true }).then((res: any) => {
      setInfo(res?.data || {});
      setdownFile(res?.data?.enclosure || []);
      optionFun.setSelectItem(res?.data || {});

      if (!res?.data?.applyStatus) {
        getcode();
      }
    }).catch(error => {
      message.destroy();
      error?.msg && message.error(error.msg);
      setInfo({});
      setdownFile([]);
    }).finally(() => { setIsloading(false); })
  }

  const newPage = (value) => {
    window.scrollTo(0, 0);
    navigate(`/enrollPlan/details?planId=${value}`)
  }

  useEffect(() => {
    init();
  }, [planId]);

  useEffect(() => {
    setCurrentIndex(optionFun?.list?.findIndex?.((item: any) => item.planId == planId));
  }, [optionFun])


  console.log(info, 'info')
  return (
    <div className="planDetails">
      <Spin spinning={isloading}>
        {info?.enableApply === 3 &&
          // <LgSealMark
          //   status={
          //     getSealMarkInfo(info).status
          //   }
          //   className={getSealMarkInfo(info).status + info?.planStatus}
          // >
          //   {getSealMarkInfo(info).text}
          // </LgSealMark>
          <img src={require(`../images/${getSealMarkInfo(info).imgSrc}`)} width={99} height={75} style={{ position: 'absolute', top: '-17px', right: '112px' }} alt="" />
        }

        <div className="plan_title">
          {info?.planName}
          <StatusTips
            style={{ color: nameTips(info || 0).color }}
            text={nameTips(info || 0).text}
          />
        </div>
        <div className="plan_desc">
          <span style={{ marginRight: 30 }}>
            发布时间：{info?.releaseTime || '--'}
          </span>
          <span>浏览次数：{info?.pageView || '--'}次</span>
        </div>

        <div className="spit"></div>

        <div className="con_list">
          <div className="list">
            <div
              className="coverimg"
              style={{
                backgroundImage: `url(${info?.coverImg?.[0]?.preUrl || ''})`,
              }}
            >
            </div>
            <div className="moremsg">
              <div style={{ marginBottom: 8 }}>
                {schoolLevel === 2 && <div>
                  计划类型:
                  <span className="content">
                    {info?.planType == 0 ? "校园招生" : "学科招生"}
                  </span>
                </div>}
                <div>
                  招生年份:
                  <span className="content">
                    {info?.planYear || '--'}
                  </span>
                </div>

                {schoolLevel === 2 && <div>
                  招生年级:
                  <span className="content">
                    {info?.planGradeName || "新年级"}
                  </span>
                </div>}

                <div>
                  招生人数:
                  <span className="content">
                    {info?.planNum || '--'}
                  </span>
                </div>
              </div>
              <div style={{ marginBottom: 8 }}>
                {schoolLevel === 2 && <div>
                  学费金额:
                  <span className="content">
                    {info?.paymentAmount || '--'}元
                  </span>
                </div>}
                {/* {schoolLevel === 2 && <div>
                  允许录取后缴费:
                  <span className="content">
                    {info?.payStatus == 0 ? "是" : "否"}
                  </span>
                </div>} */}
                <div>
                  允许在线报名:
                  <span className="content">
                    {info?.applyStatus == 0 ? "是" : "否"}
                  </span>
                </div>
                {
                    enrollInfo[info?.enrollBatchType]?
                    <div>
                    招生类型:
                    <span className="content">
                      {enrollInfo[info?.enrollBatchType]}
                    </span>
                    </div>:
                    ""
                  }
              </div>

              <div style={{ marginBottom: 8 }}>
                <div>
                  招生咨询老师:
                  <span className="content">
                    {info?.consultant?.split("-")?.[1] || '--'}
                  </span>
                </div>
                <div>
                  招生咨询电话:
                  <span className="content">
                    {info?.contact || '--'}
                  </span>
                </div>
              </div>

              <div style={{ marginBottom: 8 }}>
                <div style={{display: info?.textbookFee>0? "": "none"}}>
                  课本费:
                  <span className="content">
                    {info?.textbookFee || '--'}
                  </span>
                </div>
                <div style={{display: info?.accommodationFee>0? "": "none"}}>
                  住宿费:
                  <span className="content">
                    {info?.accommodationFee || '--'}
                  </span>
                </div>
              </div>

              <div style={{ marginBottom: 8 }}>
                <div>
                  招生计划起止时间:
                  <span className="content">
                    {((info?.planStartTime || '') + (info?.planStartTime ? '~' : '') + (info?.planEndTime || '')).replace(/-/g, '/')}
                  </span>
                </div>
                <div>
                  报名起止时间:
                  <span className="content">
                    {((info?.applyStartTime || '') + (info?.applyStartTime ? '~' : '') + (info?.applyEndTime || '') + (info?.earlyEnd ? '（已提前结束报名）' : '')).replace(/-/g, '/')}
                  </span>
                </div>
              </div>

              {
                info?.planRemake &&
                <div style={{ marginBottom: 8 }}>
                  <div>
                    备注:
                    <span className="content">
                      {info?.planRemake}
                    </span>
                  </div>
                </div>
              }

              {info?.courseList?.length > 0 && <>
                <div style={{ marginBottom: 8 }}>
                  <div style={{ display: 'flex', marginBottom: 8 }}>
                    招生学科:
                    <span className="content" style={{ maxWidth: '940px' }}>
                      {info?.courseList.map((item: any) => item.subjectName).join("、") || "--"}
                    </span>
                  </div>
                </div>
                <div style={{ marginBottom: 8 }}>
                  <div>
                    学生最多报读学科数:
                    <span className="content">
                      {info?.subjectNum || 1}
                    </span>
                  </div>
                </div>
              </>}
            </div>
          </div>

          {info?.planStatus !== 6 && !info?.earlyEnd && qrcodeUrl && <div className="btn">
            <div style={{ display: 'flex', alignItems: 'center', flexFlow: "column" }}>
              <img src={qrcodeUrl} width={120} height={120} style={{ marginBottom: 8, color: '#333333' }} />
              <span>扫码报名</span>
            </div>
          </div>}
        </div>
        <ModuleCont title='报名须知' section={1}>
          <div className="fiel_cont">
            {
              info?.noticeContent ?
                <div dangerouslySetInnerHTML={{ __html: info?.noticeContent || '--' }}></div> :
                <iframe src={info?.admissionNotice?.[0]?.content || ""} style={{ width: '100%', height: '600px' }}></iframe>
            }
          </div>
        </ModuleCont>
        {downFile?.length > 0 &&
          <ModuleCont title='附件下载' section={2}>
            {info?.enclosure?.map((ele: any) => {
              return <FileDisplay
                download={() => {
                  downloadFile(ele?.url || ele?.preUrl, ele?.originalName)
                }}
                show={() => { previewFile(ele) }}
                key={ele.md5Id || ele.resId}
                file={ele.originalName}
                panel
              />
            })}
          </ModuleCont>
        }
      </Spin>
      <div className="spit" style={{ marginBottom: 20 }}></div>
      <div className="pro_nex">
        <div>
          {currentIndex > 0 && optionFun?.list && <div onClick={() => { newPage(optionFun.list[currentIndex - 1]?.planId) }} style={{ cursor: 'pointer' }}>
            上一篇：
            <span className="onclik_cls">
              {optionFun.list[currentIndex - 1]?.planName}
            </span>
          </div>}
        </div>
        {optionFun?.list && currentIndex < optionFun?.list?.length - 1 &&
          <div onClick={() => { newPage(optionFun.list[currentIndex + 1]?.planId) }} style={{ cursor: 'pointer' }}>
            下一篇：
            <span className="onclik_cls">
              {optionFun.list[currentIndex + 1]?.planName}
            </span>
          </div>
        }
      </div>

      {(info?.enableApply === 3 || info?.planStatus === 1 && info?.applyStatus !== 1) &&
        <div className="signup-now">
          {(info?.enableApply == 2 && info?.applyStatus != 1) ?
            <div className={`ima ${(userType === 20 && userId) ? "cost" : ''}`} onClick={() => optionFun.enroll(info, 'details')} />
            : info?.enableApply === 3 ? <>
              <div className="imaNot" />
              <span className="onclik_cls" onClick={() => optionFun.enroll(info)}>
                查看{info?.planStatus === 2 ? '审核' : info?.planStatus === 3 ? info?.admissionInfo ? '录取' : '审核' : '报名'}信息
                {/* 查看{info?.admissionInfo? '录取': info?.planStatus === 2 ? '审核' : info?.planStatus === 3 ? '审核' : '报名'}信息 */}
              </span>
              {
                info?.planStatus === 2 && [2,3].includes(info?.enrollBatchType) ?
                <span 
                className={`pay-sign sign-${info?.paymentInfo?.paymentStatus===0? 3:2}`}
                onClick={() => optionFun.enroll(info)}>
                {info?.paymentInfo?.paymentStatus === 0? "待缴费": info?.paymentInfo?.paymentStatus === 1?"已缴费": info?.paymentInfo?.paymentStatus === 2? "已退费":""}
                </span>:
                ""
              }
            </> : null
          }
          {/* {
            info?.planStatus === 3 || (info?.planStatus === 1 && info?.admissionInfo?.admissionStatus === 1)?
            <span className="onclik_cls" onClick={() => optionFun.changeEnroll(true)}>
              查看录取信息
            </span>:
            ""
          } */}
        </div>
      }
      {

      }
    </div>
  )
}

export default EnrollPlanDetails
